<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import Applications from './applications';
import Comments from './comments';
import Hours from './hours';
import mentorRoles from './mentorRoles';
import Roles from './roles';
import Schedules from './schedules';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'User Profile',
		meta: [
			{
				name: 'User Profile',
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		Applications,
		Comments,
		Hours,
		mentorRoles,
		Roles,
		Schedules,
		ckeditor: CKEditor.component,
	},
	props: ['id'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userId: null,
			userTypeId: null,
			userName: null,
			autoClose: '',
			attendWorship: '',
			isKnowApplicant: '',
			cooperation: '',
			url: null,
			options: ['Yes', 'No'],
			status: [
				{ value: '1', text: 'Active' },
				{ value: '0', text: 'InActive' },
				{ value: '2', text: 'Not A Fit' },
				{ value: '3', text: 'Not 2 Years Sober' },
				{ value: '4', text: 'Do Not Contact' },
				{ value: '5', text: 'Final Incomplete / Expired' },
				{ value: '6', text: 'DHS Not Approved Final' },
				{ value: '12', text: 'PSV Not Approved' },
				{ value: '13', text: 'N/A' },
				{ value: '14', text: 'Incomplete Application' },
			],
			// { value: "11", text: "Archive" },
			assignmentStatus: [
				{ value: '1', text: 'Assigned' },
				{ value: '0', text: 'Unassigned' },
			],
			userTypeOptions: [
				{ value: 3, text: 'Mentor' },
				{ value: 4, text: 'Volunteer' },
			],
			mentorPositionTypeOptions: [
				{ value: 1, text: 'First Time Mentor' },
				{ value: 2, text: 'Returning Mentor' },
			],
			volunteerPositionTypeOptions: [
				{ value: 3, text: 'First Time Volunteer' },
				{ value: 4, text: 'Returning Volunteer' },
			],
			gender: [
				{ value: 'male', text: 'Male' },
				{ value: 'female', text: 'Female' },
			],
			sizes: [
				{ value: 'S', text: 'Adult - Small' },
				{ value: 'M', text: 'Adult - Medium' },
				{ value: 'L', text: 'Adult - Large' },
				{ value: 'XL', text: 'Adult - Extra Large' },
				{ value: 'XXL', text: 'Adult - XXL' },
				{ value: 'OTH', text: 'Other' },
			],
			position_type: '',
			contactInfoForm: {
				username: '',
				status: '',
				avatar: '',
				t_shirt: '',
				email: '',
				address: '',
				address2: '',
				phone: '',
				mobile: '',
				city: '',
				state: '',
				zip_code: '',
				age: '',
				gender: '',
				DOB: '',
				is_assigned: 0,
				approval: {},
				constituent_id: '',
			},
			basicInfoForm: {
				username: '',
				first_name: '',
				middle_name: '',
				last_name: '',
				status: '',
				t_shirt: '',
				age: '',
				is_assigned: 0,
				user_type_id: null,
				position_type_id: null,
				gender: '',
				DOB: '',
				request_start_date: '',
				application_date: '',
				approval_date: '',
				constituent_id: '',
			},
			createApprovalForm: {
				user_id: null,
				user_type_id: null,
			},
			profile: null,
			showModal: false,
			editor: ClassicEditor,
			sendEmailForm: {
				subject: '',
				description: '<p>Content of the editor.</p>',
				receiver_id: null,
			},
			created_date: null,
			dhs_background_check_complete: null,
			character_reference_confirmed: null,
			orientation_confirmed: null,
			application_approved: null,
			newPassword: '',
			isUpdatingPassword: false,
			isDeletingUser: false,
			isChangingUserLocation: false,
			isChangingUserType: false,
			isChangingUserStatus: false,
			modalTitle: '',
			userNewLocation: '',
			userNewType: '',
			availableLocations: [],
		};
	},
	mounted() {
		this.userId = this.id;
		this.getContactDetail();
		this.getAvailableLocations();
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	methods: {
		...authFackMethods,
		// Getting Current User Information
		getContactDetail() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('admin/users/' + this.userId, config)
					.then((res) => {
						if (res.status == 200) {
							this.contactInfoForm = res.data.response;
							this.userTypeId = this.contactInfoForm.user_type_id;
							this.basicInfoForm.user_type_id = this.contactInfoForm.user_type_id;
							this.basicInfoForm.position_type_id = this.contactInfoForm.position_type_id;
							this.userName = this.contactInfoForm.username;
							this.contactInfoForm.age = this.calculateAge(res.data.response.DOB);
							this.basicInfoForm.request_start_date = res.data.response.request_start_date;
							this.basicInfoForm.application_date = res.data.response.application_date;
							this.basicInfoForm.approval_date = res.data.response.approval_date;
							if (this.contactInfoForm.position_type_id == 1) {
								this.position_type = 'First Time Mentor';
							} else if (this.contactInfoForm.position_type_id == 2) {
								this.position_type = 'Returning Mentor';
							}
							this.createApprovalForm.user_id = this.userId;
							this.createApprovalForm.user_type_id = this.userTypeId;
						}
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		calculateAge(DOB) {
			var today = new Date();
			var birthDate = new Date(DOB);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		async incompleteApplication() {
			try {
				let component = this;
				component.isChangingUserStatus = true;

				let token = localStorage.getItem('token');
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isChangingUserStatus = false;
					return;
				}

				Swal.fire({
					title: 'WARNING!',
					text: "User's approval will be deleted and re-created, current approval progress will be lost.",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, Change user status',
				}).then(async (result) => {
					if (result.isConfirmed !== true) {
						component.isChangingUserStatus = false;
						return;
					}

					let config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					let data = { user_id: this.userId };
					axios
						.post('admin/update_inComplete_application_status', data, config)
						.then(async (res) => {
							if (!res || res.status != '200') {
								Swal.fire({
									title: 'Error!',
									text: 'Something went wrong',
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
								component.isChangingUserStatus = false;
								return;
							}
							Swal.fire({
								title: 'Success!',
								text: 'Status has been updated',
								icon: 'success',
								width: 350,
								showConfirmButton: true,
							});
							component.getContactDetail();
							component.isChangingUserStatus = false;
							return;
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err?.response?.data?.error?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						})
						.finally(function () {
							component.isChangingUserStatus = false;
							return;
						});
				});
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		async createApproval() {
			try {
				let component = this;
				let token = localStorage.getItem('token');
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});
					return;
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				axios
					.post('admin/registration/create-approval', component.createApprovalForm, config)
					.then(async (res) => {
						if (!res || res.status != '200') {
							Swal.fire({
								title: 'Error!',
								text: 'Something went wrong',
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
							return;
						}
						Swal.fire({
							title: 'Success!',
							text: 'Approval has been created',
							icon: 'success',
							width: 350,
							showConfirmButton: true,
						});
						component.getContactDetail();
						return;
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			} catch (error) {
				await Swal.fire({
					title: 'Error!',
					text: error?.message || 'Something went wrong',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		getFullName() {
			let fullName = '';
			if (this.contactInfoForm.first_name && this.contactInfoForm.first_name.length) {
				fullName += this.contactInfoForm.first_name;
			}
			if (this.contactInfoForm.last_name && this.contactInfoForm.last_name.length) {
				fullName += ' ' + this.contactInfoForm.last_name;
			}
			return fullName;
		},
		showBasicInfoModal() {
			this.$bvModal.show('basicInfoModal');
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('admin/users/' + this.userId, config)
					.then(async (res) => {
						if (res.status == 200) {
							this.basicInfoForm = res.data.response;
							this.url = this.contactInfoForm.avatar;
						} else if (res.status == 401) {
							await Swal.fire({
								title: 'Error!',
								text: 'Something went wrong :(',
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},
		updateProfile() {
			var formData = new FormData();
			var imagefile = document.querySelector('#file');
			formData.append('image', imagefile.files[0]);

			formData.append('first_name', this.basicInfoForm.first_name);
			formData.append('middle_name', this.basicInfoForm.middle_name);
			formData.append('last_name', this.basicInfoForm.last_name);
			formData.append('status', this.basicInfoForm.status);
			formData.append('t_shirt', this.basicInfoForm.t_shirt);
			formData.append('is_assigned', this.basicInfoForm.is_assigned);
			formData.append('user_type_id', this.basicInfoForm.user_type_id);
			formData.append('position_type_id', this.basicInfoForm.position_type_id);
			formData.append('request_start_date', this.basicInfoForm.request_start_date);
			formData.append('application_date', this.basicInfoForm.application_date);
			formData.append('approval_date', this.basicInfoForm.approval_date);
			formData.append('avatar', this.profile);
			formData.append('constituent_id', this.basicInfoForm.constituent_id);

			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					'Content-Type': 'multipart/form-data',
				},
			};
			if (token) {
				axios
					.post('admin/users/applicant/profile/' + this.userId, formData, config)
					.then(async (res) => {
						if (res.status == 200) {
							await Swal.fire({
								title: 'Success!',
								text: 'Basic Info Updated Successfully',
								icon: 'success',
								width: 350,
								showConfirmButton: true,
							});
							this.$bvModal.hide('basicInfoModal');
							this.getContactDetail();
						} else if (res.status == 401) {
							await Swal.fire({
								title: 'Error!',
								text: 'Something went wrong :(',
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},
		previewImage(e) {
			const file = e.target.files[0];
			this.url = URL.createObjectURL(file);
		},
		updateContactInfo() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				axios
					.post('admin/users/applicant/profile/' + this.userId, this.contactInfoForm, config)
					.then((res) => {
						if (res) {
							Swal.fire({
								title: 'Success!',
								text: 'Contact Info Updated Successfully',
								icon: 'success',
								width: 350,
								showConfirmButton: true,
							});
							this.getContactDetail();
						}
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},
		sendEmail() {
			this.sendEmailForm.receiver_id = [this.userId];
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.post('admin/notifications/send_mail', this.sendEmailForm, config)
					.then((res) => {
						if (res.status == '200') {
							Swal.fire({
								title: 'Success!',
								text: 'Email Sent successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.showModal = false;
							this.sendEmailForm = {
								subject: '',
								description: '',
								receiver_id: null,
							};
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},
		getApproval() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.get('admin/user/approval/' + this.userId, config)
					.then((res) => {
						if (res.status == 200) {
							this.created_date = res.data.response.created_at;
							this.dhs_background_check_complete = res.data.response.dhs_background_check_complete;
							this.character_reference_confirmed = res.data.response.character_reference_confirmed;
							this.orientation_confirmed = res.data.response.orienation_confirmed;
							this.application_approved = res.data.response.application_approved;
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		inviteUser() {
			var token = localStorage.getItem('token');
			var user = JSON.parse(localStorage.getItem('user'));
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				Swal.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to send an invitation email to this user?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes!',
				}).then((result) => {
					if (result.value) {
						axios
							.get('admin/users/mentor_invite/' + this.userId + '?rt=' + user.email, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Sent!',
										text: 'Invitation has been sent!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getContactDetail();
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err?.response?.data?.error?.message,
										icon: 'error',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				});
			}
		},
		becomeVolunteer() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			let reqData = {
				user_id: this.userId,
				user_type_id: 4,
			};
			Swal.fire({
				title: 'Are you sure?',
				text: 'Do you want to update User to Mentor/Volunteer!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				confirmButtonText: 'Yes, Update it!',
			}).then((result) => {
				if (result.value) {
					if (token) {
						// become_volunteer
						axios
							.post('admin/become_volunteer', reqData, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Updated!',
										text: 'User Updated!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getContactDetail();
								}
							})
							.catch(async (err) => {
								if (err.response) {
									await Swal.fire({
										title: 'Error!',
										text: err?.response?.data?.error?.message,
										icon: 'error',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				}
			});
		},
		async copyTextToClipboard(text = '') {
			await navigator.clipboard.writeText(text);
		},
		async updateUserPassword() {
			let component = this;
			component.isUpdatingPassword = true;

			if (!component.newPassword || component.newPassword == '') {
				await Swal.fire({
					title: 'Error!',
					text: 'New password is required',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});

				component.isUpdatingPassword = false;
				return;
			}

			let token = localStorage.getItem('token');

			if (!token) {
				await Swal.fire({
					title: 'Error!',
					text: 'Invalid login',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});

				component.isUpdatingPassword = false;
				window.location.reload();
				return;
			}

			let config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			axios
				.post(`admin/users/update-password/${component.userId}`, { new_password: component.newPassword }, config)
				.then((res) => {
					if (res.status == '200') {
						Swal.fire({
							title: 'Updated!',
							text: 'Password updated!',
							icon: 'success',
							width: 350,
							showConfirmButton: false,
							timer: 1500,
						});
						component.isUpdatingPassword = false;
						component.newPassword = '';
					}
				})
				.catch(async (err) => {
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err?.response?.data?.error?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},
		async deleteUser() {
			let component = this;
			component.isDeletingUser = true;

			let token = localStorage.getItem('token');
			if (!token) {
				await Swal.fire({
					title: 'Error!',
					text: 'Invalid login',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});

				component.isDeletingUser = false;
				return;
			}

			Swal.fire({
				title: 'Are you sure?',
				text: 'All data related to this User will be deleted permanently!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				confirmButtonText: 'Yes, Delete it!',
			}).then(async (result) => {
				if (result.isConfirmed !== true) {
					component.isDeletingUser = false;
					return;
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				axios
					.post(`admin/users/delete/${component.userId}`, config)
					.then((res) => {
						if (res.status == '200') {
							Swal.fire({
								title: 'User Deleted!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							component.isDeletingUser = false;
							component.$router.push('/resources');
							return;
						}
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					})
					.finally(function () {
						component.isDeletingUser = false;
						return;
					});
			});
		},
		openDatePicker() {
			let component = this;
			if (component.$refs['dobInput']) {
				component.$refs['dobInput'].$el.showPicker();
			}
		},
		openModal(modelId = null, modalTitle = '') {
			if (!modelId) {
				return;
			}

			let component = this;
			component.modalTitle = modalTitle;
			component.$bvModal.show(modelId);
		},
		closeModal(modelId = null) {
			if (!modelId) {
				return;
			}

			let component = this;
			component.modalTitle = '';
			component.$bvModal.hide(modelId);
		},
		async changeUserLocation() {
			try {
				let component = this;
				component.isChangingUserLocation = true;
				component.closeModal('location-change-modal');

				let token = localStorage.getItem('token');
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isChangingUserLocation = false;
					return;
				}

				let newLocationId = component.userNewLocation;
				if (!newLocationId) {
					await Swal.fire({
						title: 'Error!',
						text: 'Location not selected',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isChangingUserLocation = false;
					return;
				}

				Swal.fire({
					title: 'WARNING!',
					text: "User's approval will be deleted and re-created, current approval progress will be lost.",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, Change user location',
				}).then(async (result) => {
					if (result.isConfirmed !== true) {
						component.isChangingUserLocation = false;
						return;
					}

					let config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					axios
						.post(`admin/users/change-location/${component.userId}`, { location_id: newLocationId }, config)
						.then(async (res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'User Location Changed!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								component.userNewLocation = '';
								component.isChangingUserLocation = false;
								component.getContactDetail();

								// delete and create approval
								await component.maybeDeleteOrCreateApproval();
								return;
							}
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err?.response?.data?.error?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						})
						.finally(function () {
							component.isChangingUserLocation = false;
							return;
						});
				});
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		async changeUserType() {
			try {
				let component = this;
				component.isChangingUserType = true;
				component.closeModal('user-type-change-modal');

				let token = localStorage.getItem('token');
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isChangingUserType = false;
					return;
				}

				let newUserType = component.userNewType;
				if (!newUserType) {
					await Swal.fire({
						title: 'Error!',
						text: 'User-type not selected',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isChangingUserLocation = false;
					return;
				}

				Swal.fire({
					title: 'WARNING!',
					text: "User's approval will be deleted and re-created, current approval progress will be lost.",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, Change user-type',
				}).then(async (result) => {
					if (result.isConfirmed !== true) {
						component.isChangingUserType = false;
						return;
					}

					let config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					axios
						.post(`admin/users/change-user-type/${component.userId}`, { user_type: newUserType }, config)
						.then(async (res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'User-type Changed!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								component.userNewType = '';
								component.isChangingUserType = false;
								component.getContactDetail();

								// delete and create approval
								await component.maybeDeleteOrCreateApproval();
								return;
							}
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err?.response?.data?.error?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						})
						.finally(function () {
							component.isChangingUserType = false;
							return;
						});
				});
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		getAvailableLocations() {
			try {
				let component = this;
				axios
					.get('locations?pagination=true&per_page=1000')
					.then((res) => {
						if (res.status == '200') {
							component.availableLocations = res.data.response.data;
						}
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		async deleteApproval() {
			try {
				let component = this;
				let approvalId = component.contactInfoForm?.approval?.id;
				if (!approvalId) {
					return;
				}

				let token = localStorage.getItem('token');
				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					window.location.reload();
					return;
				}

				let response = await axios.delete('admin/user/approval/' + approvalId, config);
				if (!response || response.status != '200') {
					Swal.fire({
						title: 'Error!',
						text: 'Unable to delete Approval',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});
				}
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		async maybeDeleteOrCreateApproval() {
			try {
				let component = this;
				let approvalId = component.contactInfoForm?.approval?.id;
				if (approvalId) {
					await component.deleteApproval();
					await component.createApproval();
				}
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message,
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
			}
		},
		hasUserRoles(userRoles = [], checkUserRoles = []) {
			let hasUserRoles = false;

			if (!userRoles || userRoles.length == 0 || !checkUserRoles || checkUserRoles.length == 0) {
				return hasUserRoles;
			}

			const userRoleIds = userRoles.map((x) => x.id);
			hasUserRoles = userRoleIds.filter((roleId) => checkUserRoles.includes(roleId)).length > 0;

			return hasUserRoles;
		},
	},
	computed: {
		isApplicationComplete() {
			let component = this;
			let isApplicationComplete = false;
			const ACTIVE_STATUS = 1;

			if (!component.contactInfoForm) {
				return isApplicationComplete;
			}

			if (component?.contactInfoForm?.status != ACTIVE_STATUS) {
				isApplicationComplete = true;
			}

			return isApplicationComplete;
		},
		isUserLocationChangeable() {
			let component = this;
			return component.isApplicationComplete;
		},
		isUserTypeChangeable() {
			let component = this;
			return component.isApplicationComplete;
		},
		isValidInCompleteState() {
			let component = this;
			let isValidInCompleteState = false;
			const ACTIVE_STATUS = 1;
			const NEW_STATUS = 7;
			const INCOMPLETE_STATUS = 14;

			if (!component.contactInfoForm) {
				return isValidInCompleteState;
			}

			let condition1 = component?.contactInfoForm?.status == NEW_STATUS;
			let condition2 = component?.contactInfoForm?.status != ACTIVE_STATUS;
			let condition3 = component?.contactInfoForm?.status != INCOMPLETE_STATUS;

			// User status should be NEW or User status should not be Active and Not set to Incomplete Application
			isValidInCompleteState = condition1 || (condition2 && condition3);
			return isValidInCompleteState;
		},
		selectableLocations() {
			let component = this;
			let selectableLocations = [];
			if (component.availableLocations && component.contactInfoForm.location_id) {
				selectableLocations = Array.from(component.availableLocations).filter(function (x) {
					return x.id != component.contactInfoForm.location_id;
				});
			}
			return selectableLocations;
		},
		selectableUserTypes() {
			let component = this;
			let selectableUserTypes = [];
			if (component.contactInfoForm.user_type_id) {
				if (component.contactInfoForm.user_type_id == 3) {
					selectableUserTypes = [
						{ value: 'volunteer', text: 'Volunteer' },
						{ value: 'mentor_volunteer', text: 'Mentor/Volunteer' },
					];
				} else if (component.contactInfoForm.user_type_id == 4 && !component.contactInfoForm.is_upgraded) {
					selectableUserTypes = [
						{ value: 'mentor', text: 'Mentor' },
						{ value: 'mentor_volunteer', text: 'Mentor/Volunteer' },
					];
				} else if (component.contactInfoForm.user_type_id == 4 && component.contactInfoForm.is_upgraded) {
					selectableUserTypes = [
						{ value: 'mentor', text: 'Mentor' },
						{ value: 'volunteer', text: 'Volunteer' },
					];
				}
			}
			return selectableUserTypes;
		},
		doesStaffHasPermission() {
			let component = this;
			let doesStaffHasPermission = false;

			// System Defines User Roles/Types
			const ADMIN = 1;
			// const STAFF = 2;
			// const HR_COORDINATOR = 5;
			// const MVS_COORDINATOR = 6;
			// const CLIENT_CARE_MANAGER = 7;
			// const VOLUNTEER_LEAD = 8;
			// const ASSISTANT = 9;
			// const APPROVER = 10;
			// const NO_ROLE = 11;
			// const DIRECTOR = 12;

			let currentUserData = JSON.parse(localStorage.getItem('user'));
			if (!currentUserData) {
				return doesStaffHasPermission;
			}

			let userTypes = Array.from(currentUserData['UserTypes']);
			if (!userTypes || userTypes.length == 0) {
				return doesStaffHasPermission;
			}

			if (component.hasUserRoles(userTypes, [ADMIN])) {
				doesStaffHasPermission = true;
			}

			return doesStaffHasPermission;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<b-modal id="basicInfoModal" size="lg" centered title="User Basic Info" title-class="font-18" hide-footer>
			<form autocomplete="off">
				<div class="mb-3 preview-wrap">
					<div>
						<label>Select Profile</label>
						<b-form-file @change="previewImage" id="file" v-model="profile" accept=".jpg, .png, .gif"></b-form-file>
					</div>
					<div v-if="url">
						<div class="preview col-3 mt-2">
							<img :src="url" />
						</div>
					</div>
				</div>

				<div class="row">
					<div class="mb-3 col-4">
						<label>First Name</label>
						<input v-model="basicInfoForm.first_name" type="text" class="form-control" placeholder="Enter First Name" />
					</div>

					<div class="mb-3 col-4">
						<label>Middle Name</label>
						<input v-model="basicInfoForm.middle_name" type="text" class="form-control" placeholder="Enter Middle Name" />
					</div>

					<div class="mb-3 col-4">
						<label>Last Name</label>
						<input v-model="basicInfoForm.last_name" type="text" class="form-control" placeholder="Enter Last Name" />
					</div>
				</div>

				<div class="mb-3">
					<label class="mt-0">Select Status</label>
					<b-form-select class="form-select" v-model="basicInfoForm.status" :options="status">
						<option slot="first" :value="null" disabled>Select Status</option>
					</b-form-select>
					<small v-if="basicInfoForm.is_assigned == 1 && basicInfoForm.status != 1" class="text-danger">Assigned User must be Active</small>
					<small v-if="basicInfoForm.is_assigned == 0 && basicInfoForm.status == 1" class="text-danger">Active User must be Assigned</small>
				</div>

				<div class="row">
					<div class="mb-3 col-4">
						<label>Requested Start Date</label>
						<input v-model="basicInfoForm.request_start_date" type="date" class="form-control" placeholder="" />
					</div>
					<div class="mb-3 col-4">
						<label>Application Date</label>
						<input v-model="basicInfoForm.application_date" type="date" class="form-control" placeholder="" />
					</div>
					<div class="mb-3 col-4">
						<label>Approval Date</label>
						<input v-model="basicInfoForm.approval_date" type="date" class="form-control" placeholder="" />
					</div>
				</div>

				<div class="row">
					<div class="mb-3 col-4">
						<label class="mt-0">User Type</label>
						<b-form-select disabled class="form-select" v-model="basicInfoForm.user_type_id" :options="userTypeOptions">
							<option slot="first" :value="null" disabled>Select User Type</option>
						</b-form-select>
					</div>

					<div class="mb-3 col-4" v-if="basicInfoForm.user_type_id == 3">
						<label class="mt-0">Position Type</label>
						<b-form-select class="form-select" v-model="basicInfoForm.position_type_id" :options="mentorPositionTypeOptions">
							<option slot="first" :value="null" disabled>Select Position Type</option>
						</b-form-select>
					</div>
					<div class="mb-3 col-4" v-else-if="basicInfoForm.user_type_id == 4">
						<label class="mt-0">Position Type</label>
						<b-form-select class="form-select" v-model="basicInfoForm.position_type_id" :options="volunteerPositionTypeOptions">
							<option slot="first" :value="null" disabled>Select Position Type</option>
						</b-form-select>
					</div>
					<div class="mb-3 col-4">
						<label>Constituent ID</label>
						<input v-model="basicInfoForm.constituent_id" type="text" class="form-control" placeholder="Constituent ID" />
					</div>
				</div>

				<div class="row">
					<div class="mb-3 col-6">
						<label class="mt-0">Select Assignment Status</label>
						<b-form-select class="form-select" v-model="basicInfoForm.is_assigned" :options="assignmentStatus">
							<option slot="first" :value="null" disabled>Select Assignment Status</option>
						</b-form-select>
						<small v-if="basicInfoForm.is_assigned == 1 && basicInfoForm.status != 1" class="text-danger">Assigned User must be Active</small>
						<small v-if="basicInfoForm.is_assigned == 0 && basicInfoForm.status == 1" class="text-danger">Active User must be Assigned</small>
					</div>

					<div class="mb-3 col-6">
						<label class="mt-0">Select T-Shirt Size</label>
						<b-form-select class="form-select" v-model="basicInfoForm.t_shirt" :options="sizes">
							<option slot="first" :value="null" disabled>Select Size</option>
						</b-form-select>
					</div>
				</div>

				<div class="mb-0">
					<div>
						<button type="button" @click="updateProfile" class="btn btn-primary" :disabled="(basicInfoForm.is_assigned == 1 && basicInfoForm.status != 1) || (basicInfoForm.is_assigned == 0 && basicInfoForm.status == 1)">Save</button>
					</div>
				</div>
			</form>
		</b-modal>

		<b-modal v-model="showModal" title="Message" centered>
			<form autocomplete="off">
				<div class="mb-3">
					<input type="text" disabled v-model="contactInfoForm.username" class="form-control text-muted" placeholder="To" />
				</div>

				<div class="mb-3">
					<input type="text" v-model="sendEmailForm.subject" class="form-control" placeholder="Subject" />
				</div>

				<div class="mb-3">
					<ckeditor v-model="sendEmailForm.description" :editor="editor"></ckeditor>
				</div>
			</form>
			<template v-slot:modal-footer>
				<b-button variant="secondary" @click="showModal = false">Close</b-button>
				<b-button @click="sendEmail" variant="primary">
					Send
					<i class="fab fa-telegram-plane ms-1"></i>
				</b-button>
			</template>
		</b-modal>

		<div class="card">
			<div class="card-body">
				<div class="d-flex align-items-center justify-content-end mb-3">
					<div class="d-flex align-items-center mb-3 flex-grow-1">
						<div v-if="contactInfoForm">
							<img v-if="contactInfoForm.avatar !== null" class="rounded-circle avatar-xs me-2 img-thumbnail" :src="contactInfoForm.avatar" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
							<img v-else class="rounded-circle avatar-xs me-2 img-thumbnail" src="@/assets/images/no-image.png" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
						</div>
						<!-- <h5 class="font-size-14 mb-0">{{contactInfoForm.first_name + ' ' + contactInfoForm.last_name}}</h5> -->
						<h5 class="font-size-14 mb-0">{{ getFullName() }}</h5>
						<!-- contactInfoForm.juser_id === null &&  -->
						<router-link v-if="contactInfoForm.approval" tag="a" :to="`/approvals/user/${contactInfoForm.approval.id}/${userId}`" class="btn btn-primary ms-3"> View Approvals </router-link>
						<button v-if="contactInfoForm.approval == null" type="button" @click="createApproval" class="btn btn-primary ml-3 create-approval-btn">Create Approval</button>
					</div>

					<!-- Change user location -->
					<div class="me-1" v-if="isUserLocationChangeable && doesStaffHasPermission">
						<button type="button" @click="() => openModal('location-change-modal', 'Change User Location')" class="w-100 btn btn-primary" :disabled="isChangingUserLocation">
							<i class="mdi mdi-map-marker font-size-12 align-middle"></i>
							Change user location
						</button>
					</div>

					<!-- Change user type -->
					<div class="me-1" v-if="isUserTypeChangeable && doesStaffHasPermission">
						<button type="button" @click="() => openModal('user-type-change-modal', 'Change User-type')" class="w-100 btn btn-primary" :disabled="isChangingUserType">
							<i class="mdi mdi-account font-size-12 align-middle"></i>
							Change user type
						</button>
					</div>

					<div class="me-1" v-if="isValidInCompleteState">
						<button type="button" @click="incompleteApplication" class="w-100 btn btn-primary" :disabled="isChangingUserStatus">
							<i class="bx bxs-file font-size-18 align-middle"></i>
							Incomplete Application
						</button>
					</div>

					<!-- If Volunteer and not upgraded -->
					<div class="me-1" v-if="userTypeId == 4 && contactInfoForm.is_upgraded == 0">
						<button type="button" @click="inviteUser" class="w-100 btn btn-primary">
							<i class="bx bxs-paper-plane font-size-18 align-middle"></i>
							Invite to become a Mentor
						</button>
					</div>
					<div v-if="userTypeId == 3 && contactInfoForm.is_upgraded == 0">
						<button type="button" @click="becomeVolunteer" class="w-100 btn btn-primary">
							<i class="bx bxs-paper-plane font-size-18 align-middle"></i>
							Become a Mentor/Volunteer
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<b-tabs justified content-class="p-3 text-muted">
							<b-tab active class="border-0">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-home"></i>
									</span>
									<span class="d-none d-sm-inline-block">Profile</span>
								</template>

								<div class="row mb-4">
									<div class="col-lg-6">
										<div class="media">
											<div class="me-3" v-if="contactInfoForm">
												<div class="img-wrap">
													<img v-if="contactInfoForm.avatar !== null" class="img-thumbnail" :src="contactInfoForm.avatar" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
													<img v-else class="avatar-xl img-thumbnail" src="@/assets/images/no-image.png" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
												</div>
											</div>
											<div class="media-body align-self-center">
												<div class="text-muted">
													<span class="d-inline-block me-2 fw-bold">Status:</span>
													<span v-if="contactInfoForm.status == '1'" class="d-inline-block mb-1 me-1 text-success">Active</span>
													<span v-else-if="contactInfoForm.status == '0'" class="d-inline-block mb-1 me-1 text-danger">InActive</span>
													<span v-else-if="contactInfoForm.status == '2'" class="d-inline-block mb-1 me-1 text-danger">Not A Fit</span>
													<span v-else-if="contactInfoForm.status == '3'" class="d-inline-block mb-1 me-1 text-danger">Not 2 Years Sober</span>
													<span v-else-if="contactInfoForm.status == '4'" class="d-inline-block mb-1 me-1 text-danger">Do Not Contact</span>
													<span v-else-if="contactInfoForm.status == '5'" class="d-inline-block mb-1 me-1 text-danger">Final Incomplete / Expired</span>
													<span v-else-if="contactInfoForm.status == '6'" class="d-inline-block mb-1 me-1 text-danger">DHS Not Approved Final</span>
													<span v-else-if="contactInfoForm.status == '14'" class="d-inline-block mb-1 me-1 text-danger">Incomplete Application</span>
													<span v-else class="d-inline-block mb-1 me-1 text-danger">N/A</span>
													<br />
													<span class="d-inline-block me-2 fw-bold">User Name:</span>
													<h5 class="mb-1 me-1 d-inline-block">
														{{ getFullName() }}
													</h5>

													<p class="mb-1">
														<span class="d-inline-block me-2 fw-bold">Address:</span>
														{{ contactInfoForm.address }}
													</p>
													<p class="mb-1">
														<span class="d-inline-block me-2 fw-bold">Active Date:</span>
														<span class="d-inline-block me-2">{{ contactInfoForm.application_date | moment }}</span>
														<i title="Date" class="bx bx-calendar"></i>
													</p>

													<p class="mb-1">
														<span class="d-inline-block me-2 fw-bold">Position Type:</span>
														<span class="d-inline-block me-2">{{ position_type ? position_type : 'Not Selected' }}</span>
													</p>

													<p class="mb-1">
														<span class="d-inline-block me-2 fw-bold">Assignment Status:</span>
														<span class="d-inline-block me-2">{{ contactInfoForm.is_assigned == 1 ? 'Assigned' : 'Unassigned' }}</span>
													</p>
													<p class="mb-1">
														<span class="d-inline-block me-2 fw-bold">Preferred Location:</span>
														<span class="d-inline-block me-2">{{ contactInfoForm.location ? contactInfoForm.location : 'Not Selected' }}</span>
													</p>
													<p class="mb-0">
														<span class="d-inline-block me-2 fw-bold">Constituent ID:</span>
														<span class="d-inline-block me-2">{{ contactInfoForm.constituent_id ? contactInfoForm.constituent_id : '' }}</span>
													</p>
												</div>
											</div>

											<div class="edit-box">
												<button type="button" @click="showBasicInfoModal" class="w-50 btn btn-primary mt-3">
													<i class="bx bx-pencil font-size-18 align-middle me-1"></i>
													Edit Basic Info
												</button>
											</div>
										</div>
									</div>

									<div class="col-lg-2"></div>
									<div class="col-lg-4 roles-boxes">
										<div>
											<div v-if="contactInfoForm.UserType == 'Mentor'" class="box mentor bg-body">Mentor</div>
											<div v-if="contactInfoForm.UserType == 'Donor'" class="box donor bg-body">Donor</div>
											<div v-if="contactInfoForm.UserType == 'Program Alum'" class="box p-alum bg-body">Program Alum</div>
											<div v-if="contactInfoForm.UserType == 'Volunteer'" class="box volunteer bg-body">Volunteer</div>
											<div v-if="contactInfoForm.UserType == 'Mentor/Volunteer'" class="box volunteer bg-body">Mentor/Volunteer</div>
										</div>

										<button type="button" @click="showModal = true" class="w-100 btn btn-primary mt-3">
											<i class="bx bxs-paper-plane font-size-18 align-middle me-1"></i>
											Send Message
										</button>
									</div>
								</div>

								<div class="row mt-5">
									<div class="col-12">
										<h5 class="card-title mb-3 font-size-18">Contact Information</h5>
									</div>

									<div class="col-6 mb-3">
										<label>Address</label>
										<input type="text" v-model="contactInfoForm.address" class="form-control" placeholder="Enter Address" name="address" />
									</div>

									<div class="col-6 mb-3">
										<label>Address 2</label>
										<input v-model="contactInfoForm.address2" type="text" class="form-control" placeholder="Enter Address (Optional)" name="address2" />
									</div>

									<div class="col-4 mb-3">
										<label>City</label>
										<input v-model="contactInfoForm.city" type="text" class="form-control" placeholder="Enter City" name="city" />
									</div>

									<div class="col-4 mb-3">
										<label>State</label>
										<input v-model="contactInfoForm.state" type="text" class="form-control" placeholder="Enter State" name="state" />
									</div>

									<div class="col-4 mb-3">
										<label>Zip Code</label>
										<input type="text" v-model="contactInfoForm.zip_code" class="form-control" placeholder="Enter Zip Code" name="zip_code" />
									</div>

									<div class="col-4 mb-3">
										<label>Email Address</label>
										<b-input-group>
											<input type="text" v-model="contactInfoForm.email" class="form-control" placeholder="Enter Email Address" name="email" />
											<b-input-group-append>
												<button class="btn btn-outline-light rounded-0 rounded-right" style="border-color: #ced4da" type="button" @click="copyTextToClipboard(contactInfoForm.email)">
													<i class="mdi mdi-content-copy"></i>
												</button>
											</b-input-group-append>
										</b-input-group>
									</div>

									<div class="col-4 mb-3">
										<label>Phone Number</label>
										<input type="text" v-model="contactInfoForm.phone" class="form-control" placeholder="Enter Phone Number" name="phone" />
									</div>

									<div class="col-4 mb-3">
										<label>Alternate Number</label>
										<input type="text" v-model="contactInfoForm.mobile" class="form-control" placeholder="Enter Alternate Number" name="mobile" />
									</div>

									<div class="col-12 px-5">
										<hr />
									</div>

									<div class="col-4 mb-3">
										<label>Age</label>
										<input v-model="contactInfoForm.age" type="text" readonly disabled class="form-control" placeholder="Enter Age" />
									</div>

									<div class="col-4 mb-3">
										<label>Gender</label>
										<b-form-select class="form-select" v-model="contactInfoForm.gender" :options="gender">
											<option slot="first" :value="null" disabled>Select Gender</option>
										</b-form-select>
									</div>

									<div class="col-4 mb-3">
										<label for="dob-date-input">DOB</label>
										<b-input-group>
											<b-form-input id="dob-date-input" v-model="contactInfoForm.DOB" type="date" ref="dobInput"></b-form-input>
											<b-input-group-append>
												<button class="btn btn-outline-light rounded-0 rounded-right" style="border-color: #ced4da" type="button" @click="openDatePicker">
													<i class="mdi mdi-calendar"></i>
												</button>
											</b-input-group-append>
										</b-input-group>
									</div>

									<div class="col-12 px-5">
										<hr />
									</div>

									<div class="col-4 my-3">
										<b-input-group prepend="Update Password">
											<b-form-input v-model="newPassword" :disabled="isUpdatingPassword"></b-form-input>
											<b-input-group-append>
												<b-button text="Button" variant="outline-primary" :disabled="!newPassword || isUpdatingPassword" @click="updateUserPassword">Update</b-button>
											</b-input-group-append>
										</b-input-group>
									</div>

									<div class="col-12 px-5">
										<hr />
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="col-12 mb-3">
											<b-button @click="deleteUser" variant="outline-danger" title="Delete User" :disabled="isDeletingUser"> Delete User </b-button>
										</div>
									</div>
									<div class="col-6">
										<div class="col-12 mb-3 d-flex flex-column align-items-end">
											<b-button @click="updateContactInfo" variant="primary" title="Update User"> Update User </b-button>
										</div>
									</div>
								</div>
							</b-tab>

							<!--Applications Tab-->
							<b-tab>
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-user"></i>
									</span>
									<span class="d-none d-sm-inline-block">Application</span>
								</template>
								<div class="row mb-4">
									<div class="col-lg-4">
										<div class="p-sm-4 pb-1-5rem border border-light border-2">
											<div class="mb-3">
												<div v-if="contactInfoForm.UserType == 'Mentor'" class="box mentor bg-body">Mentor</div>
												<div v-if="contactInfoForm.UserType == 'Donor'" class="box donor bg-body">Donor</div>
												<div v-if="contactInfoForm.UserType == 'Program Alum'" class="box p-alum bg-body">Program Alum</div>
												<div v-if="contactInfoForm.UserType == 'Volunteer'" class="box volunteer bg-body">Volunteer</div>
											</div>

											<div class="text-muted">
												<p class="mb-3">
													<span class="d-inline-block me-2 fw-bold">Application ID:</span>
													<span class="d-inline-block me-2">{{ contactInfoForm.uuid }}</span>
												</p>

												<p class="mb-3">
													<span class="d-inline-block me-2 fw-bold">Application Date:</span>
													<span class="d-inline-block me-2">{{ contactInfoForm.application_date | moment }}</span>
													<i title="Date" class="bx bx-calendar"></i>
												</p>

												<p class="mb-3">
													<span class="d-inline-block me-2 fw-bold">Approval Date:</span>
													<span class="d-inline-block me-2">{{ contactInfoForm.approval_date | moment }}</span>
													<i title="Date" class="bx bx-calendar"></i>
												</p>

												<p class="mb-3">
													<span class="d-inline-block me-2 fw-bold">Requested Start Date:</span>
													<span class="d-inline-block me-2">{{ basicInfoForm.request_start_date | moment }}</span>
													<i title="Date" class="bx bx-calendar"></i>
												</p>
											</div>
										</div>
									</div>

									<div class="col-lg-8"></div>
								</div>

								<div class="row mt-2">
									<div class="col-12">
										<applications :contactInfoForm="contactInfoForm" :userId="userId" v-if="userTypeId != null" :userTypeId="userTypeId" :isMentor="contactInfoForm.is_mentor" />
									</div>
								</div>
							</b-tab>

							<!--Comments Tab-->
							<b-tab>
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-envelope"></i>
									</span>
									<span class="d-none d-sm-inline-block">Comments</span>
								</template>

								<comments :userId="userId" :userName="userName" :userEmail="contactInfoForm.email" :userLocationId="contactInfoForm.location_id" v-if="userTypeId != null" :userTypeId="userTypeId" />
							</b-tab>

							<!--Roles Tab-->
							<b-tab v-if="userTypeId == 4 || (contactInfoForm.user_type_id == 3 && contactInfoForm.is_upgraded == 1) || (contactInfoForm.user_type_id == 4 && contactInfoForm.is_upgraded == 1)">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-cog"></i>
									</span>
									<span class="d-none d-sm-inline-block">
										<span v-if="(contactInfoForm.user_type_id == 4 || contactInfoForm.user_type_id == 3) && contactInfoForm.is_upgraded == 1">Volunteer </span>
										Roles</span
									>
								</template>

								<roles :userTypeId="userTypeId" />
							</b-tab>

							<!--Schedule Tab-->
							<b-tab v-if="userTypeId == 4 || (contactInfoForm.user_type_id == 3 && contactInfoForm.is_upgraded == 1) || (contactInfoForm.user_type_id == 4 && contactInfoForm.is_upgraded == 1)">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-cog"></i>
									</span>
									<span class="d-none d-sm-inline-block">Schedule</span>
								</template>

								<schedules />
							</b-tab>

							<!--mentorRoles Tab-->
							<b-tab v-if="userTypeId == 3 || (contactInfoForm.user_type_id == 4 && contactInfoForm.is_upgraded == 1)">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-envelope"></i>
									</span>
									<span class="d-none d-sm-inline-block"><span v-if="(contactInfoForm.user_type_id == 3 && contactInfoForm.is_upgraded == 1) || (contactInfoForm.user_type_id == 4 && contactInfoForm.is_upgraded == 1)">Mentor</span> Roles</span>
								</template>

								<mentorRoles :userId="userId" :userName="userName" v-if="userTypeId != null" :userTypeId="userTypeId" />
							</b-tab>

							<!--Hours Tab-->
							<b-tab v-if="userTypeId == 3 || (userTypeId == 4 && contactInfoForm.is_mentor) || (contactInfoForm.user_type_id == 4 && contactInfoForm.is_upgraded == 1)">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-envelope"></i>
									</span>
									<span class="d-none d-sm-inline-block">Mentor Hours</span>
								</template>

								<hours :userId="userId" :userName="userName" v-if="userTypeId != null" :userTypeId="userTypeId" />
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
		</div>

		<!-- User location change modal -->
		<b-modal id="location-change-modal" size="lg" :title="modalTitle" title-class="font-18" centered hide-footer>
			<form>
				<div class="mb-3">
					<label>New Location:</label>
					<b-form-select class="form-select" v-model="userNewLocation" :options="selectableLocations" value-field="id" text-field="name">
						<option slot="first" :value="null">Select Location</option>
					</b-form-select>
				</div>

				<div class="mb-3">
					<div>
						<button type="button" class="btn btn-primary" @click="() => changeUserLocation()" :disabled="!userNewLocation">Update</button>
					</div>
				</div>
			</form>
		</b-modal>

		<!-- User type change modal -->
		<b-modal id="user-type-change-modal" size="lg" :title="modalTitle" title-class="font-18" centered hide-footer>
			<form>
				<div class="mb-3">
					<label>New Type:</label>
					<b-form-select class="form-select" v-model="userNewType" :options="selectableUserTypes">
						<option slot="first" :value="null">Select Type</option>
					</b-form-select>
				</div>

				<div class="mb-3">
					<div>
						<button type="button" class="btn btn-primary" @click="() => changeUserType()" :disabled="!userNewType">Update</button>
					</div>
				</div>
			</form>
		</b-modal>
	</Layout>
</template>
<style scoped>
.media:hover .edit-box {
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	right: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.media .edit-box {
	display: none;
	background-color: rgb(0 0 0 / 0.08);
}

.roles-boxes {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.box {
	padding: 5px;
	text-align: center;
}

.box.mentor {
	border: 2px solid #556ee6;
}

.box.donor {
	border: 2px solid #34c38f;
}

.box.p-alum {
	border: 2px solid #50a5f1;
}

.box.volunteer {
	border: 2px solid #f1b44c;
}

.chck-icon {
	font-size: 130px;
}

.pb-1-5rem {
	padding-bottom: 1.5rem !important;
}

.avatar-box {
	width: 30%;
	overflow: hidden;
	margin: 0 auto;
}

.img-wrap {
	height: 7.5rem;
	width: 7.5rem;
	position: relative;
	border: 2px solid #f6f6f6;
	border-radius: 100%;
	overflow: hidden;
}

.img-wrap img {
	width: 100%;
	position: absolute;
	left: 0px;
	right: 0px;
	top: 50%;
	transform: translateY(-50%);
}

.preview {
	position: relative;
}

.preview img {
	width: 100%;
}

.btn-remove {
	background-color: #ebecec;
	position: absolute;
	top: -15px;
	right: -15px;
	padding: 0px;
	font-size: 24px;
	border-radius: 100%;
	width: 30px;
	height: 30px;
	line-height: 30px;
	-webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
	box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}

.create-approval-btn {
	margin-left: 10px;
}

input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator {
	display: none;
	-webkit-appearance: none;
}
</style>
